import { Component, OnInit, ViewContainerRef } from '@angular/core';
import {Router} from "@angular/router";
import {LocalDataService} from "../services/local-data.service";
import {server} from "../services/index.path";
import { PublicationService } from '../nservices/publication.service';
import { CredentialsService } from '../nservices/login/credentials.service';
import { PostByUserModel,SinglePost } from '../nmodels/postbyuser.model';
import { SharedinfoService } from '../nservices/sharedinfo.service';
import { ToastsManager } from 'ng2-toastr';


@Component({
  selector: 'app-mypublications',
  templateUrl: './mypublications.component.html',
  styleUrls: ['./mypublications.component.css']
})
export class MypublicationsComponent implements OnInit {

  user_publications?:PostByUserModel;
  publications:SinglePost[];
  source = server;
  user_id;
  constructor(private _router:Router,private _localDS:LocalDataService,private _publicationS:PublicationService,private _credentialsS:CredentialsService,
              private _sharedInfoS:SharedinfoService,public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
    this.user_id = this._credentialsS.getCredentialsUserId();
    if(this.user_id){
      this._publicationS.getPublications(this.user_id)
                      .subscribe(resp =>{
                        this.user_publications = resp;
                        this.publications = this.user_publications.posts;
                        if(this.publications.length>0){
                          this.publications.reverse();
                          this.publications = this._publicationS.validatePictureofSinglePost(this.publications);
                        }else{
                          this.publications = [];
                        }
                      });
    }
  }

  ngOnInit() {
    if(!this.user_id){
      this.toastr.error('te invitamos a inicar sesion nuevamente', 'Parece que tu session ha caducado');
      // alert("Parece que tu session ha caducado, te invitamos a inicar sesion nuevamente");
      this._router.navigate['Login'];
    }
  }

  viewDetails(idx){
    this.refactorPost(idx);
    this._sharedInfoS.setasParamPostByUserModel(this.refactorPost(idx));
    this._router.navigate(['detailsmyPublication']);
  }

  editPost(idx){
    this._sharedInfoS.setasParamPostByUserModel(this.refactorPost(idx));
    this._router.navigate(['editpublication']);
  }

  deletePost(idx:number){
    console.log("Se presionó eliminar");
    if (confirm("Estas seguro de eliminar esta publicación?")) {
      if(this._credentialsS.getCredentials()){
        this._publicationS.deletePublication(this.publications[idx].id)
                         .subscribe(() => {
                           this.publications.splice(idx, 1);
                           this.toastr.success(' ya fue eliminada', ' Tu publicacion');
                          //  alert("Tu Publicación "+this.publications[idx].title+" se elimino");
                         })
      }
    }
  }

  private refactorPost(idx):PostByUserModel{
    let post:PostByUserModel = this.user_publications;
    post.posts = [this.publications[idx]];
    return post;
  }

}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/mypublications/mypublications.component.ts